<template>
	<div class="event-list">
		<div class="page-container">
			<PageTitle ch="駐村活動" en="AIR Activity"></PageTitle>

			<p class="explain">
				利澤國際偶戲藝術村的「駐村藝術家計畫」，多年來匯聚來自臺灣及世界各地的藝術家，持續舉辦工作坊、講座與駐村成果展等多元活動。這些活動不僅充分展現不同領域與專業背景的藝術家才華，為大眾帶來深度與廣度兼具的藝文體驗。除了在藝術村內舉行活動，我們也積極走入校園、社區及各具特色的場域，透過跨場域的合作與交流，激發更多創意與火花，讓藝術的影響力延伸到更廣泛的角落。
			</p>
			<p class="explain en">
				The Lize International Puppet Art Colony’s Artist-in-Residence Program has, over the years, become a vibrant platform for fostering artistic exchange and innovation. Bringing together talented artists from Taiwan and across the globe, the program offers a rich array of activities, including workshops, lectures, and the much-anticipated “Open Lab” presentations. These events celebrate the diverse skills and perspectives of participating artists, creating opportunities for the public to engage with art in ways that are both inspiring and inclusive.
			</p>
			<p class="explain en">
				Beyond the boundaries of the art village, the program actively reaches out to schools, communities, and unique local venues. By forging connections through cross-disciplinary collaborations and meaningful interactions, the residency seeks to ignite creativity and inspire new ways of thinking. Through these efforts, the Lize International Puppet Art Colony aims to broaden the impact of art, extending its transformative power to even wider audiences and fostering a deeper appreciation for artistic expression.
			</p>
			<ul class="filter">
				<li
					:key="index"
					v-for="(tag, index) in activitiesTag"
					class="f-item"
					@click="cateFilter(tag.zh)"
					:class="{ active: tag.zh == currentTag }"
				>
					<div class="ch">{{ tag.zh }}</div>
					<div class="en">{{ tag.en }}</div>
				</li>
			</ul>
			<div v-if="currentTag!=='其它活動'" class="artist-center">
				<div class="artist-lists">
					<div class="artist-card"
						:key="index"
						v-for="(item, index) in eventList.list">
						<router-link tag="div" :to="'/program/content/' + item.id">
							<img
								class="artist-img"
								:src="item.thumbs[0].url"
							></img>
							<div class="artist-title">{{ item.title }}</div>
						</router-link>
					</div>
				</div>
			</div>
			<div v-if="currentTag==='其它活動'" class="artist-center" style="margin-bottom: 50px;">
				<div class="artist-lists">
					<div class="artist-card"
						:key="item.id"
						v-for="item in others">
						<router-link tag="div" :to="'/program/activities/' + item.id">
							<img
								class="artist-img"
								:src="item.img"
							></img>
							<div class="artist-title">{{ item.title }}</div>
						</router-link>
					</div>
				</div>
			</div>
			<el-pagination
				v-if="currentTag!=='其它活動'"
				class="pagination"
				@current-change="changeCurrentPage"
				large
				layout="prev, pager, next"
				:total="totalEvents"
			>
			</el-pagination>

		</div>
	</div>
</template>

<script>
import PageTitle from "@/components/page_title";
import { mapActions, mapState } from "vuex";
import { getEvents } from "../../api/api_event"

export default {
	metaInfo: {
		title: "利澤國際偶戲藝術村"
	},
	name: "eventList",
	data() {
		return {
			currentTag:"工作坊",
			currentPop: {},
			totalEvents: 0,
			eventList:[],
			activitiesTag:[{zh: "工作坊", en: "Workshops"},
			{zh: "駐村成果展", en: "Presentation"},
			{zh: "其它活動", en: "Others"}],
			others:[{
				id:1,
				img:'/static/assets/program/activities/others/1/banner.jpg',
				title:'2024 駐村藝術家專題講座：Malte Jehmlich (德國)'
			}]
		};
	},
	mounted() {
		this.getEventsDataByPage();
	},
	methods: {
		...mapActions(["getEvent", "getEventContent"]),
		cateFilter: function(tag) {
			this.currentTag = tag;
			this.getEventByTag({ offset: 0, length: 10 });
		},
		async getEventByTag(opt){
			this.eventList = (await getEvents(this.currentTag, opt.offset, opt.length)).data
		},
		changeCurrentPage(page) {
			this.$router.push({ query: { pages: page } });
		},
		getEventsDataByPage() {
			let page = this.$route.query.pages ? this.$route.query.pages : 1;
			this.getEventByTag({ offset: (page - 1) * 10, length: 10 });
		}
	},
	computed: {
		...mapState(["eventTag"])
	},
	components: {
		PageTitle
	},
	watch: {
		$route() {
			this.getEventsDataByPage();
		},
		eventList: function() {
			this.totalEvents = this.eventList.total;
			$("html,body").scrollTop(0);
		}
	}
};
</script>
<style scoped lang="scss">
.f-item {
	margin: 3px !important;
}
.artist-lists{
	max-width: 1280px;
	margin: 35px 20px 80px;
	width: 100%;
	height: 100%;
	display: grid;
	grid-template-columns: repeat(1, minmax(0, 1fr));
	gap: 3rem 1rem;
	.artist-card{
		width: 100%;
		height: 100%;
		cursor: pointer;
		.artist-img{
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
		.artist-title{
			margin-top: 10px;
			line-height: 1.5;
		}
	}
}
@media (min-width:576px) {
	.artist-lists{
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
}
@media (min-width:768px) {
	.artist-lists{
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}
}
@media (min-width:992px) {
	.artist-lists{
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
@import '../../stylesheet/base.sass'
@import '../../stylesheet/layout.sass'
h1
	font-size: $font-size-1
	font-weight: 500
	margin-left: auto
	margin-right: auto
	margin-bottom: 12px
	margin-top: 40px
	max-width: 788px
	padding: 0 20px
.event-list
  position: relative
  .pagination
    +flexLayout('center', 'row')
    margin: 50px 0 100px

  .explain
    max-width: 788px
    width: 100%
    font-size: $font-size-3-s
    line-height: 2
    margin-left: auto
    margin-right: auto
    margin-bottom: 20px
    padding: 0 20px
  .filter
    +flexLayout('center', 'row')
    flex-wrap: wrap
    max-width: 875px
    margin: auto
    .f-item
      +flexLayout('center', 'col')
      background-color: #01b6e2
      border-radius: 100px
      min-width: 161px
      min-height: 38px
      color: white
      margin: 0 20px 32px 20px
      cursor: pointer
      opacity: 0.6
      padding: 10px 15px
      max-width: 181px
      min-width: 150px
      text-align: center
      // height: 80px
      height: 40px
      padding: 5px 5px
      margin: 0
      border-radius: 0px
      height: 65px
      width: 175px
      max-width: initial
      min-width: initial
      @media screen and (max-width: 900px)
        margin: 0
        border-radius: 0px
        height: 65px
        width: 175px
        max-width: initial
        min-width: initial
      .en
        font-size: $font-size-4
        margin-top: 5px
      &:hover
        opacity: 1
    .active
      opacity: 1
  .artist-center
    +flexLayout('center', 'row')
    width: 100%
    .center-box
      +flexLayout('center', 'row')

    .artist
      max-width: 1280px
      margin: 0 auto
      margin-bottom: 80px
      width: 100%
      .a-item
        position: relative
        height: 275px
        width: 275px
        background-size: cover
        background-position: 50% 50%
        align-self: start
        margin: 35px 0 10px 0
        filter: brightness(0.5)
        cursor: pointer
      .title
        font-size: 18px
        font-weight: 500
        color: #222
        line-height: 1.3em;
</style>
<style lang="scss">
.grid{
	width: 100%;
	display: grid;
	grid-template-columns: repeat(1, minmax(0, 1fr));
	gap: 0.5rem;
	max-width: 580px;
	margin-right: auto;
	margin-left: auto;
	margin-bottom: 100px;
	img{
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}
@media screen and (min-width: 769px){
	.grid{
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/program/program_activities.vue